
import React from 'react'
const PurchaseIcon = ({ className = "" }) => {
  return (
    <svg
      width="22.000000"
      height="22.000000"
      viewBox="0 0 22 22"
      fill="none"
      className={className}
    >
      <path
        d="M17.09 6.87C18.25 6.87 19.17 7.86 19.09 9.02L18.47 17.39C18.39 18.44 17.52 19.25 16.47 19.25L5.52 19.25C4.47 19.25 3.6 18.44 3.52 17.39L2.9 9.02C2.82 7.86 3.74 6.87 4.9 6.87L17.09 6.87Z"
        stroke="currentColor"
        strokeOpacity="1.000000"
        strokeLinejoin="round"
      />
      <path
        d="M7.33 8.7L7.33 4.75C7.33 3.64 8.22 2.75 9.33 2.75L12.66 2.75C13.77 2.75 14.66 3.64 14.66 4.75L14.66 8.7"
        stroke="currentColor"
        strokeOpacity="1.000000"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d="M7.33 15.58L14.66 15.58"
        stroke="currentColor"
        strokeOpacity="1.000000"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default PurchaseIcon;
